var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"placeholder-tip"},[_c('v-icon',{staticClass:"placeholder-tip__icon",attrs:{"name":_vm.icon}}),_c('span',{staticClass:"placeholder-tip__text"},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }